import { render, staticRenderFns } from "./ArrowWithBorder.vue?vue&type=template&id=2863853c&scoped=true&"
import script from "./ArrowWithBorder.vue?vue&type=script&lang=ts&"
export * from "./ArrowWithBorder.vue?vue&type=script&lang=ts&"
import style0 from "./ArrowWithBorder.vue?vue&type=style&index=0&id=2863853c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2863853c",
  null
  
)

export default component.exports